export default ["set_currency", "set_lang", "register_languages"].reduce(
  (sum, type) => (sum[type.toUpperCase()] = type) && sum,
  {}
);
